/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Konsultan_D3tInputs */

const en_mk_sol_konsultan_d3t = /** @type {(inputs: Mk_Sol_Konsultan_D3tInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The consultant checks the trail rather than trusting it`)
};

const id_mk_sol_konsultan_d3t = /** @type {(inputs: Mk_Sol_Konsultan_D3tInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konsultan memeriksa jejaknya, bukan mempercayainya`)
};

/**
* | output |
* | --- |
* | "The consultant checks the trail rather than trusting it" |
*
* @param {Mk_Sol_Konsultan_D3tInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_konsultan_d3t = /** @type {((inputs?: Mk_Sol_Konsultan_D3tInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Konsultan_D3tInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_konsultan_d3t(inputs)
	return en_mk_sol_konsultan_d3t(inputs)
});